import axios from '../utils/axios';

export default function addCENote(adminId, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/notes/add',  data )
    )
}